module.exports = __webpack_public_path__ + "img/telecom.4ba9f9e9.jpg";